import { render, staticRenderFns } from "./cCookieBanner.vue?vue&type=template&id=8cf12b28&scoped=true"
import script from "./cCookieBanner.vue?vue&type=script&lang=js"
export * from "./cCookieBanner.vue?vue&type=script&lang=js"
import style0 from "./cCookieBanner.vue?vue&type=style&index=0&id=8cf12b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf12b28",
  null
  
)

export default component.exports